// extracted by mini-css-extract-plugin
module.exports =  {"accordion__content":"seom__IrpGLF0WBMnR6rh3V7Uc"};